export const GRADIENT_ID_PREFIXES = {
  BUILT_IN: 'built-in-gradient',
  CUSTOM: 'custom-gradient',
};

const builtInGradients = [
  {
    id: `${GRADIENT_ID_PREFIXES.BUILT_IN}-blue-sky-white`,
    value:
      'linear-gradient(180deg, hsl(213.33, 62%, 45%) 0%, hsl(202.15, 84%, 70%) 50%, hsl(0, 0%, 96%) 100%)',
  },
  {
    id: `${GRADIENT_ID_PREFIXES.BUILT_IN}-blush-lime-periwinkle`,
    value:
      'linear-gradient(0deg, hsl(4, 48%, 94%) 0%, hsl(66, 70%, 80%) 50%, hsl(226.1, 67%, 76%) 100%)',
  },
  {
    id: `${GRADIENT_ID_PREFIXES.BUILT_IN}-peach-pink`,
    value:
      'radial-gradient(ellipse at 50% 50%, hsl(31.11, 90%, 76%) 0%, hsl(302.45, 82%, 76%) 100%)',
  },
  {
    id: `${GRADIENT_ID_PREFIXES.BUILT_IN}-midnight-lavender`,
    value: 'linear-gradient(90deg, hsl(247.5, 21%, 15%) 0%, hsl(250.34, 14%, 61%) 100%)',
  },
];

export default builtInGradients;
